import {
  CLEAR_ERRORS,
  LOADING_UI,
  LOADER_CHECK,
  LOADER_FALSE,
  ROOM_TRAINING_MANAGEMENT,
  ROOMTRAINING_CITY_FILTER,
  BUILDING_CITY_FILTER,
  FLOOR_CITY_FILTER,
  TOWER_CITY_FILTER,
  ROOM_ADD_TRAINING,
  EDIT_ROOM_ADD_TRAINING,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import axiosInstance from '../../utils/axiosInstance';
import {
  cityFilterUrl,
  buildingFilterUrl,
  TowerFilterUrl,
  FloorFilterUrl,
  RoomTrainingAdd,
  EditRoomTrainingAdd,
} from '../../Component/Helpers/api';

import $ from 'jquery';

export const RoomMaList = pageDetail => async dispatch => {
  dispatch({ type: LOADING_UI });

  // Get authToken from localStorage

  try {
    // Await the API request
    const res = await axiosInstance.post(
      `${
        process.env.REACT_APP_API_GATEWAYS_URL
      }meeting-room/api/resource/filter/all`,
      pageDetail,
      {},
    );

    // Check if the response is successful
    if (res.status === 200) {
      dispatch({ type: ROOM_TRAINING_MANAGEMENT, payload: res });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });
      return { success: true };
    } else {
      // Handle non-200 status response
      dispatch({ type: CLEAR_ERRORS });
      toast.error(res.data.status_message, {});
      return { success: false };
    }
  } catch (error) {
    // Handle any errors from the API request
    dispatch({ type: CLEAR_ERRORS });
    return { success: false };
  }
};

/*--city--*/
export const CityFilterAction = params => async dispatch => {
  // Dispatch loading action
  dispatch({ type: LOADING_UI });

  try {
    // Await the API call
    const res = await axiosInstance.get(
      `${process.env.REACT_APP_API_GATEWAYS_URL}core/cities/all`,
    );

    // Check if the response is successful
    if (res.status === 200) {
      dispatch({ type: ROOMTRAINING_CITY_FILTER, payload: res.data.data });
      dispatch({ type: CLEAR_ERRORS });
    } else {
      // Handle non-200 responses
      dispatch({ type: CLEAR_ERRORS });
    }
  } catch (error) {
    // Catch any errors during the API request
    dispatch({ type: CLEAR_ERRORS });
  }
};

/*--city--*/

/*--building--*/
export const buildingFilterAction = params => async dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));

  // Dispatch loading action
  dispatch({ type: LOADING_UI });

  try {
    // Await the API request
    const res = await axiosInstance.get(
      `${process.env.REACT_APP_API_GATEWAYS_URL}core/properties/city`,
      params,
      {},
    );

    // Check if the response status is 200
    if (res.status === 200) {
      dispatch({ type: BUILDING_CITY_FILTER, payload: res.data.data });
      dispatch({ type: CLEAR_ERRORS });
    } else {
      // Handle non-200 responses
      dispatch({ type: CLEAR_ERRORS });
    }
  } catch (error) {
    // Catch any errors during the API request
    console.error('API call failed:', error);
    dispatch({ type: CLEAR_ERRORS });
  }
};

/*--building--*/
/*--Tower--*/
export const TowerFilterAction = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  axios
    .post(TowerFilterUrl.data, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: TOWER_CITY_FILTER, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};
/*--Tower--*/
/*--Tower--*/

export const FloorFilterAction = params => async dispatch => {
  // Dispatch loading action
  dispatch({ type: LOADING_UI });

  try {
    // Await the API request
    const res = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}core/properties/all`,
      params,
      {},
    );

    // Check if the response status is 200
    if (res.status === 200) {
      dispatch({ type: FLOOR_CITY_FILTER, payload: res.data.data });
      dispatch({ type: CLEAR_ERRORS });
    } else {
      // If the response status is not 200, dispatch an error
      dispatch({ type: CLEAR_ERRORS });
    }
  } catch (error) {
    // Catch any errors during the API request
    console.error('API call failed:', error);
    dispatch({ type: CLEAR_ERRORS });
  }
};

/*--Tower--*/

export const RoomAdd = pageDetail => async dispatch => {
  try {
    // Dispatch loading action before API call
    dispatch({ type: LOADING_UI });

    // Make the API request with async/await
    const res = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}meeting-room/api/resource`,
      pageDetail,
      {},
    );

    // Check if the response status is 200 (success)
    if (res.status === 200) {
      // Dispatch success action and show success toast
      toast.success('Room Added Successfully', {});

      dispatch({ type: ROOM_ADD_TRAINING, payload: res });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Close the modal or any UI component
      $('.close').click();
    } else {
      // If status is not 200, show error message
      dispatch({ type: CLEAR_ERRORS });
      toast.error(res.data.status_message, {});
    }
  } catch (error) {
    // Catch any errors and dispatch actions to clear errors
    dispatch({ type: CLEAR_ERRORS });
    console.error('Error adding room:', error);
  } finally {
    // Ensure loader is removed regardless of success or failure
    dispatch({ type: LOADER_CHECK });
  }
};

export const editTrainingRoomForm = (
  bookingId,
  pageDetail,
) => async dispatch => {
  dispatch({ type: LOADING_UI });

  try {
    const res = await axiosInstance.put(
      `${
        process.env.REACT_APP_API_GATEWAYS_URL
      }meeting-room/api/resource/${bookingId}`,
      pageDetail,
      {},
    );

    if (res.status === 200) {
      toast.success(res.data.message, {});
      dispatch({ type: EDIT_ROOM_ADD_TRAINING, payload: res });
      $('.close').click();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(res.data.status_message, {});
    }
  } catch (error) {
    // Optional: Handle error details here (e.g., display a message)
    toast.error('An error occurred while editing the room.', {});
  } finally {
    // Clear errors and stop the loader regardless of success or failure
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: LOADER_CHECK });
  }
};

export const CheckLoader = () => dispatch => {
  dispatch({ type: LOADER_FALSE });
};
